import { setCenterlinePlanes, createCenterlinePlaneUpdater } from "../../../../src/RAWMap.Client/Visualization/CenterlineMeasurement/CenterlinePlaneHooks.js";
import { CenterlineMeasurementValueViewModel_getInteractionMode, DisplayComparisonEntryState, DisplayEntryState, getCenterlineBounds as getCenterlineBounds_1, DataEntryState, OutboundMsg, ComparisonDataEntryState, ModelCenterlineMeasurement, Mode as Mode_31, StudyCenterlineMeasurement, LocalMsg } from "./CenterlineMeasurementTypes.js";
import { toArray as toArray_1, toNullable, some, defaultArg, map } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { updatePlaneIndex, CenterlineMeasurementViewModel_toCenterlinePlanes, UnifiedBranchPointSelectionViewModel_defaultBranchSelection, Helpers_addOrUpdateMeasurements, Helpers_recomputeViewmodel, ArrayNames_fieldDataArrayNames, ArrayNames_pointDataArrayNames } from "./CenterlineMeasurementCoreTypes.js";
import { tryFind, toArray, map as map_2, ofArray, filter, append, singleton, empty } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { curry2, curry3, equals, defaultOf } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { update as update_1, wrapLocalMsg } from "../../Common/InboundOutbound.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { newGuid } from "../../fable_modules/fable-library-js.4.19.3/Guid.js";
import { Visualization_UnifiedBranch_get_toUnifiedDistanceBranch, Visualization_UnifiedBranch_get_toUnifiedTransitionBranch, Visualization_UnifiedTransitionBranch_get_defaultBranch, Visualization_UnifiedDistanceBranch_get_defaultBranch, Visualization_Centerline } from "../../RAWMap.Models/Common.js";
import { MeasurementUpdatedOutbound$2, SelectionAction$2, EditMode, CoreMeasurementValues_get_defaultPosition } from "../MeasurementsView.js";
import { UnifiedTransitionBranchPointSelectionViewModel, Bindings_PlaneIdentifier, LocalDiameterViewModel, DiameterRangeViewModel, CenterlineMeasurementValueViewModel, UnifiedBranchRangeSelectionViewModel$1, CenterlineMeasurementViewModel } from "../../RAWMap.Models/View/CenterlineMeasurement.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_either } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Result_map } from "../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { Toast_errorToast } from "../../Common/General.js";
import { CommonInteractionMode, InteractionMode, VisualizationTempInteractionMode } from "../Common/CommonBindings.js";
import { append as append_1, map as map_1 } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { TargetStudy } from "../Common/CommonTypes.js";
import { securedApi } from "../../Api.js";
import { ErrorMessage_get_describe } from "../../RAWMap.Models/ErrorMessage.js";
import { makeMeasurementEntry, makeMeasurementEntries } from "./CenterlineMeasurementPanelEntries.js";
import { append as append_2, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";

export function initializeMeasurementUpdater(meshes, pointDataArrayNames, fieldDataArrayNames, prevMeshes, prevPointDataArrayNames, prevFieldDataArrayNames, dispatch) {
    dispatch(new LocalMsg(2, [createCenterlinePlaneUpdater(meshes, pointDataArrayNames, fieldDataArrayNames, (arg) => {
        dispatch(new LocalMsg(13, [arg]));
    }), map((pm) => createCenterlinePlaneUpdater(pm, prevPointDataArrayNames, prevFieldDataArrayNames, (arg_1) => {
        dispatch(new LocalMsg(13, [arg_1]));
    }), prevMeshes)]));
}

export function init(selectedStudyId, meshes, prevMeshes) {
    let msg_1;
    return [new ModelCenterlineMeasurement(selectedStudyId, new StudyCenterlineMeasurement(meshes, ArrayNames_pointDataArrayNames, ArrayNames_fieldDataArrayNames, empty(), defaultOf()), new StudyCenterlineMeasurement(meshes, ArrayNames_pointDataArrayNames, ArrayNames_fieldDataArrayNames, empty(), defaultOf()), new Mode_31(0, []), false, false, false), (msg_1 = wrapLocalMsg(new LocalMsg(3, [])), singleton((dispatch) => {
        dispatch(msg_1);
    }))];
}

export function updateInbound(_token, msg, model) {
    let bind$0040, bind$0040_1;
    switch (msg.tag) {
        case 1:
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(0, []), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_none(), Cmd_none()];
        case 2:
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(msg.fields[0], bind$0040.PointDataArrayNames, bind$0040.FieldDataArrayNames, bind$0040.CenterlineMeasurements, bind$0040.CenterlinePlaneUpdater)), (bind$0040_1 = model.PreviousStudyMeshes, new StudyCenterlineMeasurement(msg.fields[1], bind$0040_1.PointDataArrayNames, bind$0040_1.FieldDataArrayNames, bind$0040_1.CenterlineMeasurements, bind$0040_1.CenterlinePlaneUpdater)), model.Mode, model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch) => {
                dispatch(new LocalMsg(1, []));
            }), Cmd_none()];
        default:
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(1, []), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_none(), Cmd_none()];
    }
}

export function updateLocal(token, msg, model) {
    let bind$0040_2, bind$0040_3, matchValue_4, state_1, state_2, state_3, states, matchValue_5, state_4, bind$0040_4, state_5, bind$0040_5, state_6, bind$0040_6, states_1, bind$0040_7, _arg, matchValue_7, _arg_11, _arg_13, f1_2, bind$0040_8, bind$0040_9, bind$0040_10, msg_32, bind$0040_11, bind$0040_12, bind$0040_13, msg_44, matchValue_14, vm_17, rangeSelectionVm, vm_16, _arg_15, _arg_17, _arg_19, _arg_21, _arg_23, _arg_27, _arg_25, editMode, measurementId_9, msg_94, bind$0040_21;
    const updateMeasurements = (matcher, vms) => {
        let bind$0040, bind$0040_1;
        return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(bind$0040.MaybeMeshes, bind$0040.PointDataArrayNames, bind$0040.FieldDataArrayNames, append(vms, filter((vm) => matcher(vm.currentStudyValue), model.CurrentStudyMeshes.CenterlineMeasurements)), bind$0040.CenterlinePlaneUpdater)), (bind$0040_1 = model.PreviousStudyMeshes, new StudyCenterlineMeasurement(bind$0040_1.MaybeMeshes, bind$0040_1.PointDataArrayNames, bind$0040_1.FieldDataArrayNames, append(vms, filter((vm_1) => defaultArg(map(matcher, vm_1.maybePreviousStudyValue), true), model.PreviousStudyMeshes.CenterlineMeasurements)), bind$0040_1.CenterlinePlaneUpdater)), model.Mode, model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch) => {
            dispatch(new LocalMsg(25, [undefined]));
        }), Cmd_none()];
    };
    const addMeasurement_1 = (isComparisonMode) => {
        if (isComparisonMode) {
            return (getValue_1) => ((interactionMode_1) => {
                const patternInput = [model.CurrentStudyMeshes.CenterlinePlaneUpdater.getUnifiedBranchIndexBounds().wallBounds, model.PreviousStudyMeshes.CenterlinePlaneUpdater.getUnifiedBranchIndexBounds().wallBounds];
                const measurement = new CenterlineMeasurementViewModel(newGuid(), model.SelectedStudyId, "", getValue_1(patternInput[0]), getValue_1(patternInput[1]), new Visualization_Centerline(1, []), CoreMeasurementValues_get_defaultPosition());
                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(3, [new ComparisonDataEntryState(measurement, [], [], [], [], newGuid(), newGuid())]), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_batch(ofArray([singleton((dispatch_4) => {
                    dispatch_4(new LocalMsg(12, []));
                }), singleton((dispatch_5) => {
                    dispatch_5(new LocalMsg(25, [[measurement.measurementId, new EditMode(1, [])]]));
                })])), singleton((dispatch_6) => {
                    dispatch_6(new OutboundMsg(2, [interactionMode_1]));
                })];
            });
        }
        else {
            return (getValue) => ((interactionMode) => {
                const bounds = model.CurrentStudyMeshes.CenterlinePlaneUpdater.getUnifiedBranchIndexBounds().wallBounds;
                const newMeasurement = new CenterlineMeasurementViewModel(newGuid(), model.SelectedStudyId, "", getValue(bounds), undefined, new Visualization_Centerline(1, []), CoreMeasurementValues_get_defaultPosition());
                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(2, [new DataEntryState(newMeasurement, [], [], newGuid())]), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_batch(ofArray([singleton((dispatch_1) => {
                    dispatch_1(new LocalMsg(12, []));
                }), singleton((dispatch_2) => {
                    dispatch_2(new LocalMsg(25, [[newMeasurement.measurementId, new EditMode(1, [])]]));
                })])), singleton((dispatch_3) => {
                    dispatch_3(new OutboundMsg(2, [interactionMode]));
                })];
            });
        }
    };
    const deleteMeasurement = (deleteApi, mid) => {
        let f1;
        return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, model.IsEditingLabels, true, model.IsSaving), Cmd_OfAsyncWith_either((x_1) => {
            Cmd_OfAsync_start(x_1);
        }, deleteApi, [mid, model.SelectedStudyId], (f1 = Result_map()((r) => [r, mid]), (arg_1) => (new LocalMsg(29, [f1(arg_1)]))), (Item_11) => (new LocalMsg(0, [Item_11]))), Cmd_none()];
    };
    const recomputeViewmodel = (updatedMeasurements_1, target, vm_11, callbackId, planePipelines) => {
        const patternInput_1 = (target.tag === 1) ? [model.PreviousStudyMeshes.CenterlinePlaneUpdater, vm_11.maybePreviousStudyValue] : [model.CurrentStudyMeshes.CenterlinePlaneUpdater, vm_11.currentStudyValue];
        return Helpers_recomputeViewmodel(updatedMeasurements_1, patternInput_1[1], callbackId, vm_11.centerline, patternInput_1[0], (cvm) => {
            if (target.tag === 1) {
                return new CenterlineMeasurementViewModel(vm_11.measurementId, vm_11.studyId, vm_11.name, vm_11.currentStudyValue, cvm, vm_11.centerline, vm_11.labelPosition);
            }
            else {
                return new CenterlineMeasurementViewModel(vm_11.measurementId, vm_11.studyId, vm_11.name, cvm, vm_11.maybePreviousStudyValue, vm_11.centerline, vm_11.labelPosition);
            }
        }, () => getCenterlineBounds_1(model, target, vm_11), vm_11, planePipelines);
    };
    let matchResult, ex, currentUpdater, previousUpdater, setter, updatedPosition, measurement_2, vms_1, vms_2, vms_3, vms_4, e, isComparisonMode_1, isComparisonMode_2, isComparisonMode_3, isComparisonMode_4, status, vm_14, status_1, vm_15, e_1, centerline_4, branch_4, index, planeIdentifier, targetStudy, measurementId_4, stopShowingId, measurementId_8, maybeSelectionAction, mid_1, deleted, status_2, e_2;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            currentUpdater = msg.fields[0];
            previousUpdater = msg.fields[1];
            break;
        }
        case 30: {
            matchResult = 3;
            setter = msg.fields[0];
            break;
        }
        case 31: {
            matchResult = 4;
            break;
        }
        case 32: {
            matchResult = 5;
            updatedPosition = msg.fields[0];
            break;
        }
        case 13: {
            matchResult = 6;
            measurement_2 = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 7;
            break;
        }
        case 4: {
            if (msg.fields[0].tag === 1) {
                matchResult = 12;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 8;
                vms_1 = msg.fields[0].fields[0];
            }
            break;
        }
        case 5: {
            if (msg.fields[0].tag === 1) {
                matchResult = 12;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 9;
                vms_2 = msg.fields[0].fields[0];
            }
            break;
        }
        case 6: {
            if (msg.fields[0].tag === 1) {
                matchResult = 12;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 10;
                vms_3 = msg.fields[0].fields[0];
            }
            break;
        }
        case 7: {
            if (msg.fields[0].tag === 1) {
                matchResult = 12;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 11;
                vms_4 = msg.fields[0].fields[0];
            }
            break;
        }
        case 8: {
            matchResult = 13;
            isComparisonMode_1 = msg.fields[0];
            break;
        }
        case 9: {
            matchResult = 14;
            isComparisonMode_2 = msg.fields[0];
            break;
        }
        case 10: {
            matchResult = 15;
            isComparisonMode_3 = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 16;
            isComparisonMode_4 = msg.fields[0];
            break;
        }
        case 12: {
            matchResult = 17;
            break;
        }
        case 14: {
            if (msg.fields[0].tag === 1) {
                matchResult = 20;
                e_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 18;
                status = msg.fields[0].fields[0][0];
                vm_14 = msg.fields[0].fields[0][1];
            }
            break;
        }
        case 15: {
            if (msg.fields[0].tag === 1) {
                matchResult = 20;
                e_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 19;
                status_1 = msg.fields[0].fields[0][0];
                vm_15 = msg.fields[0].fields[0][1];
            }
            break;
        }
        case 16: {
            matchResult = 21;
            break;
        }
        case 17: {
            matchResult = 22;
            centerline_4 = msg.fields[0];
            break;
        }
        case 18: {
            matchResult = 23;
            branch_4 = msg.fields[0];
            break;
        }
        case 19: {
            matchResult = 24;
            index = msg.fields[1];
            planeIdentifier = msg.fields[0];
            targetStudy = msg.fields[2];
            break;
        }
        case 20: {
            matchResult = 25;
            measurementId_4 = msg.fields[0];
            break;
        }
        case 21: {
            matchResult = 26;
            stopShowingId = msg.fields[0];
            break;
        }
        case 22: {
            matchResult = 27;
            measurementId_8 = msg.fields[0];
            break;
        }
        case 23: {
            matchResult = 28;
            break;
        }
        case 24: {
            matchResult = 29;
            break;
        }
        case 25: {
            matchResult = 30;
            maybeSelectionAction = msg.fields[0];
            break;
        }
        case 26: {
            matchResult = 31;
            break;
        }
        case 27: {
            matchResult = 32;
            mid_1 = msg.fields[0];
            break;
        }
        case 29: {
            if (msg.fields[0].tag === 1) {
                matchResult = 34;
                e_2 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 33;
                deleted = msg.fields[0].fields[0][1];
                status_2 = msg.fields[0].fields[0][0];
            }
            break;
        }
        case 28: {
            matchResult = 35;
            break;
        }
        default: {
            matchResult = 0;
            ex = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0: {
            console.error(some(toText(printf("CenterlineMeasurement exception: %O"))(ex)));
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, model.IsEditingLabels, model.IsDeleting, false), Toast_errorToast("An error has occured"), Cmd_none()];
        }
        case 1: {
            const matchValue_1 = model.CurrentStudyMeshes.MaybeMeshes;
            if (matchValue_1 == null) {
                console.error(some("Expected a value for meshes but was None"));
                return [model, Cmd_none(), Cmd_none()];
            }
            else {
                const currMeshes = matchValue_1;
                return [model, Cmd_ofEffect((dispatch_7) => {
                    initializeMeasurementUpdater(currMeshes, model.CurrentStudyMeshes.PointDataArrayNames, model.CurrentStudyMeshes.FieldDataArrayNames, model.PreviousStudyMeshes.MaybeMeshes, model.PreviousStudyMeshes.PointDataArrayNames, model.PreviousStudyMeshes.FieldDataArrayNames, dispatch_7);
                }), Cmd_none()];
            }
        }
        case 2:
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040_2 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(bind$0040_2.MaybeMeshes, bind$0040_2.PointDataArrayNames, bind$0040_2.FieldDataArrayNames, bind$0040_2.CenterlineMeasurements, currentUpdater)), (bind$0040_3 = model.PreviousStudyMeshes, new StudyCenterlineMeasurement(bind$0040_3.MaybeMeshes, bind$0040_3.PointDataArrayNames, bind$0040_3.FieldDataArrayNames, bind$0040_3.CenterlineMeasurements, toNullable(previousUpdater))), model.Mode, model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_none(), Cmd_none()];
        case 3:
            return [(matchValue_4 = model.Mode, (matchValue_4.tag === 4) ? ((state_1 = matchValue_4.fields[0], new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(4, [new DataEntryState(setter(state_1.vm), state_1.centerlinePointMeasurements, state_1.planePipelines, state_1.expectedCallbackId)]), model.IsEditingLabels, model.IsDeleting, model.IsSaving))) : ((matchValue_4.tag === 5) ? ((state_2 = matchValue_4.fields[0], new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(5, [new ComparisonDataEntryState(setter(state_2.vm), state_2.currentCenterlinePointMeasurements, state_2.previousCenterlinePointMeasurements, state_2.currentPlanePipelines, state_2.previousPlanePipelines, state_2.currentExpectedCallbackId, state_2.previousExpectedCallbackId)]), model.IsEditingLabels, model.IsDeleting, model.IsSaving))) : ((matchValue_4.tag === 2) ? ((state_3 = matchValue_4.fields[0], new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(2, [new DataEntryState(setter(state_3.vm), state_3.centerlinePointMeasurements, state_3.planePipelines, state_3.expectedCallbackId)]), model.IsEditingLabels, model.IsDeleting, model.IsSaving))) : ((matchValue_4.tag === 3) ? ((states = matchValue_4.fields[0], new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(3, [new ComparisonDataEntryState(setter(states.vm), states.currentCenterlinePointMeasurements, states.previousCenterlinePointMeasurements, states.currentPlanePipelines, states.previousPlanePipelines, states.currentExpectedCallbackId, states.previousExpectedCallbackId)]), model.IsEditingLabels, model.IsDeleting, model.IsSaving))) : model)))), singleton((dispatch_8) => {
                dispatch_8(new LocalMsg(25, [undefined]));
            }), Cmd_none()];
        case 4:
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, true, model.IsDeleting, model.IsSaving), Cmd_none(), singleton((dispatch_9) => {
                dispatch_9(new OutboundMsg(2, [new InteractionMode(1, [new VisualizationTempInteractionMode(1, [])])]));
            })];
        case 5: {
            const model_1 = new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, false, model.IsDeleting, model.IsSaving);
            return [(matchValue_5 = model_1.Mode, (matchValue_5.tag === 4) ? ((state_4 = matchValue_5.fields[0], new ModelCenterlineMeasurement(model_1.SelectedStudyId, model_1.CurrentStudyMeshes, model_1.PreviousStudyMeshes, new Mode_31(4, [new DataEntryState((bind$0040_4 = state_4.vm, new CenterlineMeasurementViewModel(bind$0040_4.measurementId, bind$0040_4.studyId, bind$0040_4.name, bind$0040_4.currentStudyValue, bind$0040_4.maybePreviousStudyValue, bind$0040_4.centerline, updatedPosition)), state_4.centerlinePointMeasurements, state_4.planePipelines, state_4.expectedCallbackId)]), model_1.IsEditingLabels, model_1.IsDeleting, model_1.IsSaving))) : ((matchValue_5.tag === 5) ? ((state_5 = matchValue_5.fields[0], new ModelCenterlineMeasurement(model_1.SelectedStudyId, model_1.CurrentStudyMeshes, model_1.PreviousStudyMeshes, new Mode_31(5, [new ComparisonDataEntryState((bind$0040_5 = state_5.vm, new CenterlineMeasurementViewModel(bind$0040_5.measurementId, bind$0040_5.studyId, bind$0040_5.name, bind$0040_5.currentStudyValue, bind$0040_5.maybePreviousStudyValue, bind$0040_5.centerline, updatedPosition)), state_5.currentCenterlinePointMeasurements, state_5.previousCenterlinePointMeasurements, state_5.currentPlanePipelines, state_5.previousPlanePipelines, state_5.currentExpectedCallbackId, state_5.previousExpectedCallbackId)]), model_1.IsEditingLabels, model_1.IsDeleting, model_1.IsSaving))) : ((matchValue_5.tag === 2) ? ((state_6 = matchValue_5.fields[0], new ModelCenterlineMeasurement(model_1.SelectedStudyId, model_1.CurrentStudyMeshes, model_1.PreviousStudyMeshes, new Mode_31(2, [new DataEntryState((bind$0040_6 = state_6.vm, new CenterlineMeasurementViewModel(bind$0040_6.measurementId, bind$0040_6.studyId, bind$0040_6.name, bind$0040_6.currentStudyValue, bind$0040_6.maybePreviousStudyValue, bind$0040_6.centerline, updatedPosition)), state_6.centerlinePointMeasurements, state_6.planePipelines, state_6.expectedCallbackId)]), model_1.IsEditingLabels, model_1.IsDeleting, model_1.IsSaving))) : ((matchValue_5.tag === 3) ? ((states_1 = matchValue_5.fields[0], new ModelCenterlineMeasurement(model_1.SelectedStudyId, model_1.CurrentStudyMeshes, model_1.PreviousStudyMeshes, new Mode_31(3, [new ComparisonDataEntryState((bind$0040_7 = states_1.vm, new CenterlineMeasurementViewModel(bind$0040_7.measurementId, bind$0040_7.studyId, bind$0040_7.name, bind$0040_7.currentStudyValue, bind$0040_7.maybePreviousStudyValue, bind$0040_7.centerline, updatedPosition)), states_1.currentCenterlinePointMeasurements, states_1.previousCenterlinePointMeasurements, states_1.currentPlanePipelines, states_1.previousPlanePipelines, states_1.currentExpectedCallbackId, states_1.previousExpectedCallbackId)]), model_1.IsEditingLabels, model_1.IsDeleting, model_1.IsSaving))) : model_1)))), Cmd_none(), singleton((dispatch_10) => {
                dispatch_10(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(2, [])])]));
            })];
        }
        case 6: {
            const matchValue_6 = model.Mode;
            let matchResult_1, state_9;
            switch (matchValue_6.tag) {
                case 2: {
                    if (measurement_2.callbackIdentifier === matchValue_6.fields[0].expectedCallbackId) {
                        matchResult_1 = 0;
                        state_9 = matchValue_6.fields[0];
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    break;
                }
                case 4: {
                    if (measurement_2.callbackIdentifier === matchValue_6.fields[0].expectedCallbackId) {
                        matchResult_1 = 0;
                        state_9 = matchValue_6.fields[0];
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    break;
                }
                default:
                    matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    let updatedMeasurements_2;
                    const state = state_9;
                    const measurement_1 = measurement_2;
                    updatedMeasurements_2 = (state.centerlinePointMeasurements.some((c) => equals(c.planeIdentifier, measurement_1.planeIdentifier)) ? map_1((existingMeasurement) => {
                        if (equals(existingMeasurement.planeIdentifier, measurement_1.planeIdentifier)) {
                            return measurement_1;
                        }
                        else {
                            return existingMeasurement;
                        }
                    }, state.centerlinePointMeasurements) : append_1([measurement_1], state.centerlinePointMeasurements));
                    const patternInput_2 = recomputeViewmodel(updatedMeasurements_2, new TargetStudy(0, []), state_9.vm, state_9.expectedCallbackId, state_9.planePipelines);
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg = model.Mode, (_arg.tag === 2) ? ((Item_14) => (new Mode_31(2, [Item_14]))) : ((_arg.tag === 4) ? ((Item_15) => (new Mode_31(4, [Item_15]))) : ((_arg_1) => (new Mode_31(0, []))))))(new DataEntryState(patternInput_2[0], updatedMeasurements_2, patternInput_2[1], state_9.expectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_11) => {
                        dispatch_11(new LocalMsg(25, [undefined]));
                    }), Cmd_none()];
                }
                default: {
                    let matchResult_2, states_2;
                    switch (matchValue_6.tag) {
                        case 5: {
                            matchResult_2 = 0;
                            states_2 = matchValue_6.fields[0];
                            break;
                        }
                        case 3: {
                            matchResult_2 = 0;
                            states_2 = matchValue_6.fields[0];
                            break;
                        }
                        default:
                            matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0: {
                            const updateComparisonModel = (state_10, target_1) => {
                                let _arg_2;
                                const patternInput_3 = (target_1.tag === 1) ? [state_10.previousCenterlinePointMeasurements, state_10.previousPlanePipelines, state_10.previousExpectedCallbackId] : [state_10.currentCenterlinePointMeasurements, state_10.currentPlanePipelines, state_10.currentExpectedCallbackId];
                                const updatedMeasurements_3 = Helpers_addOrUpdateMeasurements(patternInput_3[0], measurement_2);
                                const patternInput_4 = recomputeViewmodel(updatedMeasurements_3, target_1, state_10.vm, patternInput_3[2], patternInput_3[1]);
                                const updatedVm_1 = patternInput_4[0];
                                const updatedPipelines_1 = patternInput_4[1];
                                const updatedModel = (target_1.tag === 1) ? (new ComparisonDataEntryState(updatedVm_1, state_10.currentCenterlinePointMeasurements, updatedMeasurements_3, state_10.currentPlanePipelines, updatedPipelines_1, state_10.currentExpectedCallbackId, state_10.previousExpectedCallbackId)) : (new ComparisonDataEntryState(updatedVm_1, updatedMeasurements_3, state_10.previousCenterlinePointMeasurements, updatedPipelines_1, state_10.previousPlanePipelines, state_10.currentExpectedCallbackId, state_10.previousExpectedCallbackId));
                                return new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_2 = model.Mode, (_arg_2.tag === 3) ? ((Item_17) => (new Mode_31(3, [Item_17]))) : ((_arg_2.tag === 5) ? ((Item_18) => (new Mode_31(5, [Item_18]))) : ((_arg_3) => (new Mode_31(0, []))))))(updatedModel), model.IsEditingLabels, model.IsDeleting, model.IsSaving);
                            };
                            return [(matchValue_7 = measurement_2.callbackIdentifier, (matchValue_7 === states_2.currentExpectedCallbackId) ? updateComparisonModel(states_2, new TargetStudy(0, [])) : ((matchValue_7 === states_2.previousExpectedCallbackId) ? updateComparisonModel(states_2, new TargetStudy(1, [])) : model)), singleton((dispatch_12) => {
                                dispatch_12(new LocalMsg(25, [undefined]));
                            }), Cmd_none()];
                        }
                        default:
                            return [model, Cmd_none(), Cmd_none()];
                    }
                }
            }
        }
        case 7:
            return [model, Cmd_batch(map_2((tupledArg) => Cmd_OfAsyncWith_either((x_2) => {
                Cmd_OfAsync_start(x_2);
            }, tupledArg[0], model.SelectedStudyId, tupledArg[1], (Item_20) => (new LocalMsg(0, [Item_20]))), ofArray([[securedApi(token).getCenterlineDistanceMeasurementsForStudy, (Item_21) => (new LocalMsg(4, [Item_21]))], [securedApi(token).getDiameterRangeMeasurementsForStudy, (Item_22) => (new LocalMsg(5, [Item_22]))], [securedApi(token).getLocalDiameterMeasurementsForStudy, (Item_23) => (new LocalMsg(6, [Item_23]))], [securedApi(token).getCenterlineVolumeMeasurementsForStudy, (Item_24) => (new LocalMsg(7, [Item_24]))]]))), Cmd_none()];
        case 8:
            return updateMeasurements((_arg_4) => {
                if (_arg_4.tag === 0) {
                    return false;
                }
                else {
                    return true;
                }
            }, vms_1);
        case 9:
            return updateMeasurements((_arg_5) => {
                if (_arg_5.tag === 1) {
                    return false;
                }
                else {
                    return true;
                }
            }, vms_2);
        case 10:
            return updateMeasurements((_arg_6) => {
                if (_arg_6.tag === 2) {
                    return false;
                }
                else {
                    return true;
                }
            }, vms_3);
        case 11:
            return updateMeasurements((_arg_7) => {
                if (_arg_7.tag === 3) {
                    return false;
                }
                else {
                    return true;
                }
            }, vms_4);
        case 12:
            return [model, Toast_errorToast(ErrorMessage_get_describe()(e)), Cmd_none()];
        case 13:
            return addMeasurement_1(isComparisonMode_1)((branchIndexBounds_1) => {
                let getMaxTrunkIndex, branchIndexBounds, branch_1;
                return new CenterlineMeasurementValueViewModel(0, [[(getMaxTrunkIndex = ((branchIndexBounds = branchIndexBounds_1, (branch) => ((branch.tag === 1) ? branchIndexBounds.distanceTrunk.lastIndex : ((branch.tag === 2) ? branchIndexBounds.distanceTrunkCusp.lastIndex : branchIndexBounds.distanceTrunk.lastIndex)))), (branch_1 = Visualization_UnifiedDistanceBranch_get_defaultBranch(), new UnifiedBranchRangeSelectionViewModel$1(branch_1, 0, getMaxTrunkIndex(branch_1)))), 0]]);
            })(new InteractionMode(0, [new CommonInteractionMode(2, [])]));
        case 14:
            return addMeasurement_1(isComparisonMode_2)((branchIndexBounds_2) => (new CenterlineMeasurementValueViewModel(1, [[new UnifiedBranchRangeSelectionViewModel$1(Visualization_UnifiedTransitionBranch_get_defaultBranch(), 0, branchIndexBounds_2.transitionTrunk.lastIndex), new DiameterRangeViewModel(0, 0)]])))(new InteractionMode(1, [new VisualizationTempInteractionMode(3, [])]));
        case 15:
            return addMeasurement_1(isComparisonMode_3)((_arg_9) => (new CenterlineMeasurementValueViewModel(2, [[UnifiedBranchPointSelectionViewModel_defaultBranchSelection, new LocalDiameterViewModel(0, 0, 0, undefined)]])))(new InteractionMode(0, [new CommonInteractionMode(3, [])]));
        case 16:
            return addMeasurement_1(isComparisonMode_4)((branchIndexBounds_3) => (new CenterlineMeasurementValueViewModel(3, [[new UnifiedBranchRangeSelectionViewModel$1(Visualization_UnifiedTransitionBranch_get_defaultBranch(), 0, branchIndexBounds_3.transitionTrunk.lastIndex), undefined, 0]])))(new InteractionMode(0, [new CommonInteractionMode(4, [])]));
        case 17: {
            const matchValue_8 = model.Mode;
            let matchResult_3, state_11, states_3;
            switch (matchValue_8.tag) {
                case 2: {
                    matchResult_3 = 0;
                    state_11 = matchValue_8.fields[0];
                    break;
                }
                case 4: {
                    matchResult_3 = 0;
                    state_11 = matchValue_8.fields[0];
                    break;
                }
                case 3: {
                    matchResult_3 = 1;
                    states_3 = matchValue_8.fields[0];
                    break;
                }
                case 5: {
                    matchResult_3 = 1;
                    states_3 = matchValue_8.fields[0];
                    break;
                }
                default:
                    matchResult_3 = 2;
            }
            switch (matchResult_3) {
                case 0: {
                    const updatedPipelines_2 = setCenterlinePlanes(model.CurrentStudyMeshes.CenterlinePlaneUpdater, toArray(CenterlineMeasurementViewModel_toCenterlinePlanes(state_11.expectedCallbackId, state_11.vm.centerline, state_11.vm.currentStudyValue)));
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_11 = model.Mode, (_arg_11.tag === 2) ? ((Item_25) => (new Mode_31(2, [Item_25]))) : ((_arg_11.tag === 4) ? ((Item_26) => (new Mode_31(4, [Item_26]))) : ((_arg_12) => (new Mode_31(0, []))))))(new DataEntryState(state_11.vm, state_11.centerlinePointMeasurements, updatedPipelines_2, state_11.expectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_none(), Cmd_none()];
                }
                case 1: {
                    const planes_1 = (i, centerline_3, arg_5) => toArray(CenterlineMeasurementViewModel_toCenterlinePlanes(i, centerline_3, arg_5));
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_13 = model.Mode, (_arg_13.tag === 3) ? ((Item_27) => (new Mode_31(3, [Item_27]))) : ((_arg_13.tag === 5) ? ((Item_28) => (new Mode_31(5, [Item_28]))) : ((_arg_14) => (new Mode_31(0, []))))))(new ComparisonDataEntryState(states_3.vm, states_3.currentCenterlinePointMeasurements, states_3.previousCenterlinePointMeasurements, setCenterlinePlanes(model.CurrentStudyMeshes.CenterlinePlaneUpdater, planes_1(states_3.currentExpectedCallbackId, states_3.vm.centerline, states_3.vm.currentStudyValue)), defaultArg(map((f1_2 = curry3(planes_1)(states_3.previousExpectedCallbackId)(states_3.vm.centerline), (arg_6) => setCenterlinePlanes(model.PreviousStudyMeshes.CenterlinePlaneUpdater, f1_2(arg_6))), states_3.vm.maybePreviousStudyValue), []), states_3.currentExpectedCallbackId, states_3.previousExpectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_none(), Cmd_none()];
                }
                default:
                    return [model, Cmd_none(), Cmd_none()];
            }
        }
        case 18: {
            const matchValue_9 = model.Mode;
            switch (matchValue_9.tag) {
                case 2:
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040_8 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(bind$0040_8.MaybeMeshes, bind$0040_8.PointDataArrayNames, bind$0040_8.FieldDataArrayNames, append(singleton(vm_14), model.CurrentStudyMeshes.CenterlineMeasurements), bind$0040_8.CenterlinePlaneUpdater)), model.PreviousStudyMeshes, new Mode_31(6, [new DisplayEntryState(vm_14, matchValue_9.fields[0].planePipelines)]), model.IsEditingLabels, model.IsDeleting, false), singleton((dispatch_13) => {
                        dispatch_13(new LocalMsg(25, [[vm_14.measurementId, new EditMode(0, [])]]));
                    }), Cmd_batch(ofArray([singleton((dispatch_14) => {
                        dispatch_14(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(0, [])])]));
                    }), singleton((dispatch_15) => {
                        dispatch_15(new OutboundMsg(0, [status]));
                    })]))];
                case 3: {
                    const state_13 = matchValue_9.fields[0];
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040_9 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(bind$0040_9.MaybeMeshes, bind$0040_9.PointDataArrayNames, bind$0040_9.FieldDataArrayNames, append(singleton(vm_14), model.CurrentStudyMeshes.CenterlineMeasurements), bind$0040_9.CenterlinePlaneUpdater)), (bind$0040_10 = model.PreviousStudyMeshes, new StudyCenterlineMeasurement(bind$0040_10.MaybeMeshes, bind$0040_10.PointDataArrayNames, bind$0040_10.FieldDataArrayNames, append(singleton(vm_14), model.PreviousStudyMeshes.CenterlineMeasurements), bind$0040_10.CenterlinePlaneUpdater)), new Mode_31(7, [new DisplayComparisonEntryState(vm_14, state_13.currentPlanePipelines, state_13.previousPlanePipelines)]), model.IsEditingLabels, model.IsDeleting, false), singleton((dispatch_16) => {
                        dispatch_16(new LocalMsg(25, [[vm_14.measurementId, new EditMode(0, [])]]));
                    }), Cmd_batch(ofArray([singleton((dispatch_17) => {
                        dispatch_17(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(0, [])])]));
                    }), singleton((dispatch_18) => {
                        dispatch_18(new OutboundMsg(0, [status]));
                    })]))];
                }
                default:
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, model.IsEditingLabels, model.IsDeleting, false), (msg_32 = (new LocalMsg(0, [new Error("Unable to display saved measurement")])), singleton((dispatch_19) => {
                        dispatch_19(msg_32);
                    })), Cmd_none()];
            }
        }
        case 19: {
            const matchValue_10 = model.Mode;
            switch (matchValue_10.tag) {
                case 4:
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040_11 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(bind$0040_11.MaybeMeshes, bind$0040_11.PointDataArrayNames, bind$0040_11.FieldDataArrayNames, map_2((measurement_4) => {
                        if (measurement_4.measurementId === vm_15.measurementId) {
                            return vm_15;
                        }
                        else {
                            return measurement_4;
                        }
                    }, model.CurrentStudyMeshes.CenterlineMeasurements), bind$0040_11.CenterlinePlaneUpdater)), model.PreviousStudyMeshes, new Mode_31(6, [new DisplayEntryState(vm_15, matchValue_10.fields[0].planePipelines)]), model.IsEditingLabels, model.IsDeleting, false), singleton((dispatch_20) => {
                        dispatch_20(new LocalMsg(25, [[vm_15.measurementId, new EditMode(0, [])]]));
                    }), Cmd_batch(ofArray([singleton((dispatch_21) => {
                        dispatch_21(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(0, [])])]));
                    }), singleton((dispatch_22) => {
                        dispatch_22(new OutboundMsg(0, [status_1]));
                    })]))];
                case 5: {
                    const state_15 = matchValue_10.fields[0];
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040_12 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(bind$0040_12.MaybeMeshes, bind$0040_12.PointDataArrayNames, bind$0040_12.FieldDataArrayNames, map_2((measurement_5) => {
                        if (measurement_5.measurementId === vm_15.measurementId) {
                            return vm_15;
                        }
                        else {
                            return measurement_5;
                        }
                    }, model.CurrentStudyMeshes.CenterlineMeasurements), bind$0040_12.CenterlinePlaneUpdater)), (bind$0040_13 = model.PreviousStudyMeshes, new StudyCenterlineMeasurement(bind$0040_13.MaybeMeshes, bind$0040_13.PointDataArrayNames, bind$0040_13.FieldDataArrayNames, map_2((measurement_6) => {
                        if (measurement_6.measurementId === vm_15.measurementId) {
                            return vm_15;
                        }
                        else {
                            return measurement_6;
                        }
                    }, model.PreviousStudyMeshes.CenterlineMeasurements), bind$0040_13.CenterlinePlaneUpdater)), new Mode_31(7, [new DisplayComparisonEntryState(vm_15, state_15.currentPlanePipelines, state_15.previousPlanePipelines)]), model.IsEditingLabels, model.IsDeleting, false), singleton((dispatch_23) => {
                        dispatch_23(new LocalMsg(25, [[vm_15.measurementId, new EditMode(0, [])]]));
                    }), Cmd_batch(ofArray([singleton((dispatch_24) => {
                        dispatch_24(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(0, [])])]));
                    }), singleton((dispatch_25) => {
                        dispatch_25(new OutboundMsg(0, [status_1]));
                    })]))];
                }
                default:
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, model.IsEditingLabels, model.IsDeleting, false), (msg_44 = (new LocalMsg(0, [new Error("Unable to display saved measurement")])), singleton((dispatch_26) => {
                        dispatch_26(msg_44);
                    })), Cmd_none()];
            }
        }
        case 20: {
            const matchValue_11 = model.Mode;
            if (matchValue_11.tag === 2) {
                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, model.IsEditingLabels, model.IsDeleting, false), Cmd_batch(ofArray([singleton((dispatch_27) => {
                    dispatch_27(new LocalMsg(25, [[matchValue_11.fields[0].vm.measurementId, new EditMode(1, [])]]));
                }), Toast_errorToast(ErrorMessage_get_describe()(e_1))])), Cmd_none()];
            }
            else {
                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, model.IsEditingLabels, model.IsDeleting, false), Toast_errorToast(ErrorMessage_get_describe()(e_1)), Cmd_none()];
            }
        }
        case 21: {
            const matchValue_12 = model.Mode;
            switch (matchValue_12.tag) {
                case 4: {
                    const state_17 = matchValue_12.fields[0];
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(6, [new DisplayEntryState(state_17.vm, state_17.planePipelines)]), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_batch(ofArray([singleton((dispatch_30) => {
                        dispatch_30(new LocalMsg(25, [[state_17.vm.measurementId, new EditMode(0, [])]]));
                    }), singleton((dispatch_31) => {
                        dispatch_31(new LocalMsg(20, [state_17.vm.measurementId]));
                    })])), singleton((dispatch_32) => {
                        dispatch_32(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(0, [])])]));
                    })];
                }
                case 5: {
                    const state_18 = matchValue_12.fields[0];
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(7, [new DisplayComparisonEntryState(state_18.vm, state_18.currentPlanePipelines, state_18.previousPlanePipelines)]), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_batch(ofArray([singleton((dispatch_33) => {
                        dispatch_33(new LocalMsg(25, [[state_18.vm.measurementId, new EditMode(0, [])]]));
                    }), singleton((dispatch_34) => {
                        dispatch_34(new LocalMsg(20, [state_18.vm.measurementId]));
                    })])), singleton((dispatch_35) => {
                        dispatch_35(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(0, [])])]));
                    })];
                }
                default:
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(0, []), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_28) => {
                        dispatch_28(new LocalMsg(25, [undefined]));
                    }), singleton((dispatch_29) => {
                        dispatch_29(new OutboundMsg(2, [new InteractionMode(0, [new CommonInteractionMode(0, [])])]));
                    })];
            }
        }
        case 22: {
            const matchValue_13 = model.Mode;
            let matchResult_4, state_19, states_4;
            switch (matchValue_13.tag) {
                case 2: {
                    matchResult_4 = 0;
                    state_19 = matchValue_13.fields[0];
                    break;
                }
                case 4: {
                    matchResult_4 = 0;
                    state_19 = matchValue_13.fields[0];
                    break;
                }
                case 3: {
                    matchResult_4 = 1;
                    states_4 = matchValue_13.fields[0];
                    break;
                }
                case 5: {
                    matchResult_4 = 1;
                    states_4 = matchValue_13.fields[0];
                    break;
                }
                default:
                    matchResult_4 = 2;
            }
            switch (matchResult_4) {
                case 0: {
                    let updatedVm_2;
                    const bind$0040_14 = state_19.vm;
                    updatedVm_2 = (new CenterlineMeasurementViewModel(bind$0040_14.measurementId, bind$0040_14.studyId, bind$0040_14.name, bind$0040_14.currentStudyValue, bind$0040_14.maybePreviousStudyValue, centerline_4, bind$0040_14.labelPosition));
                    const changeIndexMessages = map_2((tupledArg_1) => (new LocalMsg(19, [tupledArg_1[0], tupledArg_1[1], new TargetStudy(0, [])])), (matchValue_14 = state_19.vm.currentStudyValue, (matchValue_14.tag === 1) ? ((vm_17 = matchValue_14.fields[0][0], ofArray([[new Bindings_PlaneIdentifier(0, []), vm_17.firstIndex], [new Bindings_PlaneIdentifier(1, []), vm_17.secondIndex]]))) : ((matchValue_14.tag === 2) ? singleton([new Bindings_PlaneIdentifier(0, []), matchValue_14.fields[0][0].index]) : ((matchValue_14.tag === 3) ? ((rangeSelectionVm = matchValue_14.fields[0][0], append(ofArray([[new Bindings_PlaneIdentifier(0, []), rangeSelectionVm.firstIndex], [new Bindings_PlaneIdentifier(1, []), rangeSelectionVm.secondIndex]]), ofArray(toArray_1(map((pointSelectionVm) => [new Bindings_PlaneIdentifier(2, []), pointSelectionVm.index], matchValue_14.fields[0][1])))))) : ((vm_16 = matchValue_14.fields[0][0], ofArray([[new Bindings_PlaneIdentifier(0, []), vm_16.firstIndex], [new Bindings_PlaneIdentifier(1, []), vm_16.secondIndex]])))))));
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_15 = model.Mode, (_arg_15.tag === 2) ? ((Item_31) => (new Mode_31(2, [Item_31]))) : ((_arg_15.tag === 4) ? ((Item_32) => (new Mode_31(4, [Item_32]))) : ((_arg_16) => (new Mode_31(0, []))))))(new DataEntryState(updatedVm_2, new Array(0), state_19.planePipelines, state_19.expectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_batch(map_2((msg_64) => singleton((dispatch_36) => {
                        dispatch_36(msg_64);
                    }), changeIndexMessages)), Cmd_none()];
                }
                case 1: {
                    let updatedVm_3;
                    const bind$0040_15 = states_4.vm;
                    updatedVm_3 = (new CenterlineMeasurementViewModel(bind$0040_15.measurementId, bind$0040_15.studyId, bind$0040_15.name, bind$0040_15.currentStudyValue, bind$0040_15.maybePreviousStudyValue, centerline_4, bind$0040_15.labelPosition));
                    const updatedMeasurements_5 = new Array(0);
                    const changeIndexMessages_1 = (target_2, vm_19) => {
                        let vm_21, rangeSelectionVm_1, vm_20;
                        return map_2((tupledArg_2) => (new LocalMsg(19, [tupledArg_2[0], tupledArg_2[1], target_2])), (vm_19.tag === 1) ? ((vm_21 = vm_19.fields[0][0], ofArray([[new Bindings_PlaneIdentifier(0, []), vm_21.firstIndex], [new Bindings_PlaneIdentifier(1, []), vm_21.secondIndex]]))) : ((vm_19.tag === 2) ? singleton([new Bindings_PlaneIdentifier(0, []), vm_19.fields[0][0].index]) : ((vm_19.tag === 3) ? ((rangeSelectionVm_1 = vm_19.fields[0][0], append(ofArray([[new Bindings_PlaneIdentifier(0, []), rangeSelectionVm_1.firstIndex], [new Bindings_PlaneIdentifier(1, []), rangeSelectionVm_1.secondIndex]]), ofArray(toArray_1(map((pointSelectionVm_1) => [new Bindings_PlaneIdentifier(2, []), pointSelectionVm_1.index], vm_19.fields[0][1])))))) : ((vm_20 = vm_19.fields[0][0], ofArray([[new Bindings_PlaneIdentifier(0, []), vm_20.firstIndex], [new Bindings_PlaneIdentifier(1, []), vm_20.secondIndex]]))))));
                    };
                    const maybePreviousMessages = defaultArg(map(curry2(changeIndexMessages_1)(new TargetStudy(1, [])), states_4.vm.maybePreviousStudyValue), empty());
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_17 = model.Mode, (_arg_17.tag === 3) ? ((Item_33) => (new Mode_31(3, [Item_33]))) : ((_arg_17.tag === 5) ? ((Item_34) => (new Mode_31(5, [Item_34]))) : ((_arg_18) => (new Mode_31(0, []))))))(new ComparisonDataEntryState(updatedVm_3, updatedMeasurements_5, updatedMeasurements_5, states_4.currentPlanePipelines, states_4.previousPlanePipelines, states_4.currentExpectedCallbackId, states_4.previousExpectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_batch(map_2((msg_66) => singleton((dispatch_37) => {
                        dispatch_37(msg_66);
                    }), append(maybePreviousMessages, changeIndexMessages_1(new TargetStudy(0, []), states_4.vm.currentStudyValue)))), Cmd_none()];
                }
                default:
                    return [model, Cmd_none(), Cmd_none()];
            }
        }
        case 23: {
            const updateTransitionRangeSelectionBranch = (rangeSelectionVm_3) => (new UnifiedBranchRangeSelectionViewModel$1(Visualization_UnifiedBranch_get_toUnifiedTransitionBranch()(branch_4), rangeSelectionVm_3.firstIndex, rangeSelectionVm_3.secondIndex));
            const updateTransitionPointSelectionBranch = (pointSelectionVm_2) => (new UnifiedTransitionBranchPointSelectionViewModel(Visualization_UnifiedBranch_get_toUnifiedTransitionBranch()(branch_4), pointSelectionVm_2.index));
            const updatedValue = (vm_23) => {
                let rangeSelectionVm_2;
                switch (vm_23.tag) {
                    case 1:
                        return new CenterlineMeasurementValueViewModel(1, [[updateTransitionRangeSelectionBranch(vm_23.fields[0][0]), vm_23.fields[0][1]]]);
                    case 2:
                        return new CenterlineMeasurementValueViewModel(2, [[updateTransitionPointSelectionBranch(vm_23.fields[0][0]), vm_23.fields[0][1]]]);
                    case 3:
                        return new CenterlineMeasurementValueViewModel(3, [[updateTransitionRangeSelectionBranch(vm_23.fields[0][0]), map(updateTransitionPointSelectionBranch, vm_23.fields[0][1]), vm_23.fields[0][2]]]);
                    default:
                        return new CenterlineMeasurementValueViewModel(0, [[(rangeSelectionVm_2 = vm_23.fields[0][0], new UnifiedBranchRangeSelectionViewModel$1(Visualization_UnifiedBranch_get_toUnifiedDistanceBranch()(branch_4), rangeSelectionVm_2.firstIndex, rangeSelectionVm_2.secondIndex)), vm_23.fields[0][1]]]);
                }
            };
            const updatedMeasurements_6 = new Array(0);
            const matchValue_15 = model.Mode;
            let matchResult_5, state_20, states_5;
            switch (matchValue_15.tag) {
                case 2: {
                    matchResult_5 = 0;
                    state_20 = matchValue_15.fields[0];
                    break;
                }
                case 4: {
                    matchResult_5 = 0;
                    state_20 = matchValue_15.fields[0];
                    break;
                }
                case 3: {
                    matchResult_5 = 1;
                    states_5 = matchValue_15.fields[0];
                    break;
                }
                case 5: {
                    matchResult_5 = 1;
                    states_5 = matchValue_15.fields[0];
                    break;
                }
                default:
                    matchResult_5 = 2;
            }
            switch (matchResult_5) {
                case 0: {
                    let updatedVm_4;
                    const bind$0040_16 = state_20.vm;
                    updatedVm_4 = (new CenterlineMeasurementViewModel(bind$0040_16.measurementId, bind$0040_16.studyId, bind$0040_16.name, updatedValue(state_20.vm.currentStudyValue), bind$0040_16.maybePreviousStudyValue, bind$0040_16.centerline, bind$0040_16.labelPosition));
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_19 = model.Mode, (_arg_19.tag === 2) ? ((Item_35) => (new Mode_31(2, [Item_35]))) : ((_arg_19.tag === 4) ? ((Item_36) => (new Mode_31(4, [Item_36]))) : ((_arg_20) => (new Mode_31(0, []))))))(new DataEntryState(updatedVm_4, updatedMeasurements_6, state_20.planePipelines, state_20.expectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_38) => {
                        dispatch_38(new LocalMsg(12, []));
                    }), Cmd_none()];
                }
                case 1: {
                    let updatedCurrentVm;
                    const bind$0040_17 = states_5.vm;
                    updatedCurrentVm = (new CenterlineMeasurementViewModel(bind$0040_17.measurementId, bind$0040_17.studyId, bind$0040_17.name, updatedValue(states_5.vm.currentStudyValue), map(updatedValue, states_5.vm.maybePreviousStudyValue), bind$0040_17.centerline, bind$0040_17.labelPosition));
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_21 = model.Mode, (_arg_21.tag === 3) ? ((Item_37) => (new Mode_31(3, [Item_37]))) : ((_arg_21.tag === 5) ? ((Item_38) => (new Mode_31(5, [Item_38]))) : ((_arg_22) => (new Mode_31(0, []))))))(new ComparisonDataEntryState(updatedCurrentVm, updatedMeasurements_6, updatedMeasurements_6, states_5.currentPlanePipelines, states_5.previousPlanePipelines, states_5.currentExpectedCallbackId, states_5.previousExpectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_39) => {
                        dispatch_39(new LocalMsg(12, []));
                    }), Cmd_none()];
                }
                default:
                    return [model, Cmd_none(), Cmd_none()];
            }
        }
        case 24: {
            const matchValue_16 = model.Mode;
            let matchResult_6, state_23;
            switch (matchValue_16.tag) {
                case 2: {
                    if (index >= 0) {
                        matchResult_6 = 0;
                        state_23 = matchValue_16.fields[0];
                    }
                    else {
                        matchResult_6 = 1;
                    }
                    break;
                }
                case 4: {
                    if (index >= 0) {
                        matchResult_6 = 0;
                        state_23 = matchValue_16.fields[0];
                    }
                    else {
                        matchResult_6 = 1;
                    }
                    break;
                }
                default:
                    matchResult_6 = 1;
            }
            switch (matchResult_6) {
                case 0: {
                    let updatedVm_5;
                    const bind$0040_18 = state_23.vm;
                    updatedVm_5 = (new CenterlineMeasurementViewModel(bind$0040_18.measurementId, bind$0040_18.studyId, bind$0040_18.name, updatePlaneIndex(getCenterlineBounds_1(model, targetStudy, state_23.vm), planeIdentifier, index, state_23.vm.currentStudyValue), bind$0040_18.maybePreviousStudyValue, bind$0040_18.centerline, bind$0040_18.labelPosition));
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_23 = model.Mode, (_arg_23.tag === 2) ? ((Item_39) => (new Mode_31(2, [Item_39]))) : ((_arg_23.tag === 4) ? ((Item_40) => (new Mode_31(4, [Item_40]))) : ((_arg_24) => (new Mode_31(0, []))))))(new DataEntryState(updatedVm_5, new Array(0), state_23.planePipelines, newGuid())), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_40) => {
                        dispatch_40(new LocalMsg(12, []));
                    }), Cmd_none()];
                }
                default: {
                    let matchResult_7, states_6;
                    switch (matchValue_16.tag) {
                        case 3: {
                            matchResult_7 = 0;
                            states_6 = matchValue_16.fields[0];
                            break;
                        }
                        case 5: {
                            matchResult_7 = 0;
                            states_6 = matchValue_16.fields[0];
                            break;
                        }
                        default:
                            matchResult_7 = 1;
                    }
                    switch (matchResult_7) {
                        case 0:
                            if (targetStudy.tag === 1) {
                                const branchIndexBounds_6 = getCenterlineBounds_1(model, targetStudy, states_6.vm);
                                let updatedPrevVm;
                                const bind$0040_20 = states_6.vm;
                                updatedPrevVm = (new CenterlineMeasurementViewModel(bind$0040_20.measurementId, bind$0040_20.studyId, bind$0040_20.name, bind$0040_20.currentStudyValue, map((vm_24) => updatePlaneIndex(branchIndexBounds_6, planeIdentifier, index, vm_24), states_6.vm.maybePreviousStudyValue), bind$0040_20.centerline, bind$0040_20.labelPosition));
                                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_27 = model.Mode, (_arg_27.tag === 3) ? ((Item_43) => (new Mode_31(3, [Item_43]))) : ((_arg_27.tag === 5) ? ((Item_44) => (new Mode_31(5, [Item_44]))) : ((_arg_28) => (new Mode_31(0, []))))))(new ComparisonDataEntryState(updatedPrevVm, states_6.currentCenterlinePointMeasurements, new Array(0), states_6.currentPlanePipelines, states_6.previousPlanePipelines, states_6.currentExpectedCallbackId, newGuid())), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_42) => {
                                    dispatch_42(new LocalMsg(12, []));
                                }), Cmd_none()];
                            }
                            else {
                                let updatedCurrentVm_1;
                                const bind$0040_19 = states_6.vm;
                                updatedCurrentVm_1 = (new CenterlineMeasurementViewModel(bind$0040_19.measurementId, bind$0040_19.studyId, bind$0040_19.name, updatePlaneIndex(getCenterlineBounds_1(model, targetStudy, states_6.vm), planeIdentifier, index, states_6.vm.currentStudyValue), bind$0040_19.maybePreviousStudyValue, bind$0040_19.centerline, bind$0040_19.labelPosition));
                                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, ((_arg_25 = model.Mode, (_arg_25.tag === 3) ? ((Item_41) => (new Mode_31(3, [Item_41]))) : ((_arg_25.tag === 5) ? ((Item_42) => (new Mode_31(5, [Item_42]))) : ((_arg_26) => (new Mode_31(0, []))))))(new ComparisonDataEntryState(updatedCurrentVm_1, new Array(0), states_6.previousCenterlinePointMeasurements, states_6.currentPlanePipelines, states_6.previousPlanePipelines, newGuid(), states_6.previousExpectedCallbackId)), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_41) => {
                                    dispatch_41(new LocalMsg(12, []));
                                }), Cmd_none()];
                            }
                        default:
                            return [model, Cmd_none(), Cmd_none()];
                    }
                }
            }
        }
        case 25: {
            const toShow = tryFind((measurement_7) => (measurement_7.measurementId === measurementId_4), model.CurrentStudyMeshes.CenterlineMeasurements);
            const second = tryFind((measurement_8) => (measurement_8.measurementId === measurementId_4), model.PreviousStudyMeshes.CenterlineMeasurements);
            const pipes = (centerline_5, meshes, cm) => setCenterlinePlanes(meshes.CenterlinePlaneUpdater, toArray(CenterlineMeasurementViewModel_toCenterlinePlanes(newGuid(), centerline_5, cm)));
            let patternInput_5;
            if (toShow == null) {
                patternInput_5 = [new Mode_31(0, []), Cmd_none()];
            }
            else if (second == null) {
                const c_2 = toShow;
                patternInput_5 = [new Mode_31(6, [new DisplayEntryState(c_2, pipes(c_2.centerline, model.CurrentStudyMeshes, c_2.currentStudyValue))]), singleton((dispatch_45) => {
                    dispatch_45(new OutboundMsg(3, [false]));
                })];
            }
            else {
                const c_1 = toShow;
                const p = second;
                const matchValue_18 = p.maybePreviousStudyValue;
                if (matchValue_18 == null) {
                    patternInput_5 = [new Mode_31(6, [new DisplayEntryState(c_1, pipes(c_1.centerline, model.CurrentStudyMeshes, c_1.currentStudyValue))]), singleton((dispatch_44) => {
                        dispatch_44(new OutboundMsg(3, [false]));
                    })];
                }
                else {
                    const prev = matchValue_18;
                    patternInput_5 = [new Mode_31(7, [new DisplayComparisonEntryState(c_1, pipes(c_1.centerline, model.CurrentStudyMeshes, c_1.currentStudyValue), pipes(c_1.centerline, model.PreviousStudyMeshes, prev))]), singleton((dispatch_43) => {
                        dispatch_43(new OutboundMsg(3, [true]));
                    })];
                }
            }
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, patternInput_5[0], model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_none(), patternInput_5[1]];
        }
        case 26: {
            const matchValue_19 = model.Mode;
            let matchResult_8, measurementId_7;
            switch (matchValue_19.tag) {
                case 0:
                case 1:
                case 6:
                case 7: {
                    matchResult_8 = 0;
                    break;
                }
                case 2: {
                    if (stopShowingId === matchValue_19.fields[0].vm.measurementId) {
                        matchResult_8 = 1;
                        measurementId_7 = matchValue_19.fields[0].vm.measurementId;
                    }
                    else {
                        matchResult_8 = 2;
                    }
                    break;
                }
                case 4: {
                    if (stopShowingId === matchValue_19.fields[0].vm.measurementId) {
                        matchResult_8 = 1;
                        measurementId_7 = matchValue_19.fields[0].vm.measurementId;
                    }
                    else {
                        matchResult_8 = 2;
                    }
                    break;
                }
                default:
                    matchResult_8 = 2;
            }
            switch (matchResult_8) {
                case 0:
                    return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, new Mode_31(0, []), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_none(), Cmd_none()];
                case 1:
                    return [model, singleton((dispatch_46) => {
                        dispatch_46(new LocalMsg(16, []));
                    }), Cmd_none()];
                default: {
                    let matchResult_9, states_9, states_10;
                    switch (matchValue_19.tag) {
                        case 2:
                        case 4: {
                            matchResult_9 = 2;
                            break;
                        }
                        case 5: {
                            if (matchValue_19.fields[0].vm.measurementId === stopShowingId) {
                                matchResult_9 = 0;
                                states_9 = matchValue_19.fields[0];
                            }
                            else {
                                matchResult_9 = 2;
                            }
                            break;
                        }
                        case 3: {
                            if (matchValue_19.fields[0].vm.measurementId === stopShowingId) {
                                matchResult_9 = 1;
                                states_10 = matchValue_19.fields[0];
                            }
                            else {
                                matchResult_9 = 2;
                            }
                            break;
                        }
                        default:
                            matchResult_9 = 3;
                    }
                    switch (matchResult_9) {
                        case 0:
                            return [model, singleton((dispatch_47) => {
                                dispatch_47(new LocalMsg(16, []));
                            }), Cmd_none()];
                        case 1:
                            return [model, singleton((dispatch_48) => {
                                dispatch_48(new LocalMsg(16, []));
                            }), Cmd_none()];
                        case 2:
                            return [model, Cmd_none(), Cmd_none()];
                        default:
                            throw new Error("Match failure: RAWMap.Client.Visualization.CenterlineMeasurement.Types.Mode");
                    }
                }
            }
        }
        case 27:
            return defaultArg(map((newMeasurement_3) => {
                let newMeasurement_1, matchValue_20, state_25, msg_91;
                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, (newMeasurement_1 = newMeasurement_3, (matchValue_20 = model.Mode, (matchValue_20.tag === 6) ? (new Mode_31(4, [new DataEntryState(newMeasurement_1, [], matchValue_20.fields[0].planePipelines, newGuid())])) : ((matchValue_20.tag === 7) ? ((state_25 = matchValue_20.fields[0], new Mode_31(5, [new ComparisonDataEntryState(newMeasurement_1, [], [], state_25.currentPlanePipelines, state_25.previousPlanePipelines, newGuid(), newGuid())]))) : model.Mode))), model.IsEditingLabels, model.IsDeleting, model.IsSaving), Cmd_batch(ofArray([singleton((dispatch_49) => {
                    dispatch_49(new LocalMsg(12, []));
                }), singleton((dispatch_50) => {
                    dispatch_50(new LocalMsg(25, [[newMeasurement_3.measurementId, new EditMode(1, [])]]));
                })])), (msg_91 = (new OutboundMsg(2, [CenterlineMeasurementValueViewModel_getInteractionMode(newMeasurement_3.currentStudyValue)])), singleton((dispatch_51) => {
                    dispatch_51(msg_91);
                }))];
            }, tryFind((measurement_9) => (measurement_9.measurementId === measurementId_8), model.CurrentStudyMeshes.CenterlineMeasurements)), [model, Toast_errorToast("Failed to find measurement in list"), Cmd_none()]);
        case 28:
            return [model, singleton((dispatch_52) => {
                dispatch_52(new LocalMsg(16, []));
            }), Cmd_none()];
        case 29: {
            let matchValue;
            const mode = model.Mode;
            let matchResult_10, vm_2, vm_3, vm_4, vm_5, vm_6, vm_7, vm_8, vm_9;
            switch (mode.tag) {
                case 2: {
                    switch (mode.fields[0].vm.currentStudyValue.tag) {
                        case 1: {
                            matchResult_10 = 1;
                            vm_3 = mode.fields[0].vm;
                            break;
                        }
                        case 2: {
                            matchResult_10 = 2;
                            vm_4 = mode.fields[0].vm;
                            break;
                        }
                        case 3: {
                            matchResult_10 = 3;
                            vm_5 = mode.fields[0].vm;
                            break;
                        }
                        default: {
                            matchResult_10 = 0;
                            vm_2 = mode.fields[0].vm;
                        }
                    }
                    break;
                }
                case 3: {
                    switch (mode.fields[0].vm.currentStudyValue.tag) {
                        case 1: {
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 1) {
                                    matchResult_10 = 1;
                                    vm_3 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                            break;
                        }
                        case 2: {
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 2) {
                                    matchResult_10 = 2;
                                    vm_4 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                            break;
                        }
                        case 3: {
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 3) {
                                    matchResult_10 = 3;
                                    vm_5 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                            break;
                        }
                        default:
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 0) {
                                    matchResult_10 = 0;
                                    vm_2 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                    }
                    break;
                }
                case 4: {
                    switch (mode.fields[0].vm.currentStudyValue.tag) {
                        case 1: {
                            matchResult_10 = 5;
                            vm_7 = mode.fields[0].vm;
                            break;
                        }
                        case 2: {
                            matchResult_10 = 6;
                            vm_8 = mode.fields[0].vm;
                            break;
                        }
                        case 3: {
                            matchResult_10 = 7;
                            vm_9 = mode.fields[0].vm;
                            break;
                        }
                        default: {
                            matchResult_10 = 4;
                            vm_6 = mode.fields[0].vm;
                        }
                    }
                    break;
                }
                case 5: {
                    switch (mode.fields[0].vm.currentStudyValue.tag) {
                        case 1: {
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 1) {
                                    matchResult_10 = 5;
                                    vm_7 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                            break;
                        }
                        case 2: {
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 2) {
                                    matchResult_10 = 6;
                                    vm_8 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                            break;
                        }
                        case 3: {
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 3) {
                                    matchResult_10 = 7;
                                    vm_9 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                            break;
                        }
                        default:
                            if (mode.fields[0].vm.maybePreviousStudyValue != null) {
                                if (mode.fields[0].vm.maybePreviousStudyValue.tag === 0) {
                                    matchResult_10 = 4;
                                    vm_6 = mode.fields[0].vm;
                                }
                                else {
                                    matchResult_10 = 8;
                                }
                            }
                            else {
                                matchResult_10 = 8;
                            }
                    }
                    break;
                }
                default:
                    matchResult_10 = 8;
            }
            switch (matchResult_10) {
                case 0: {
                    matchValue = [securedApi(token).createCenterlineDistanceMeasurement, vm_2, (Item_1) => (new LocalMsg(14, [Item_1]))];
                    break;
                }
                case 1: {
                    matchValue = [securedApi(token).createDiameterRangeMeasurement, vm_3, (Item_2) => (new LocalMsg(14, [Item_2]))];
                    break;
                }
                case 2: {
                    matchValue = [securedApi(token).createLocalDiameterMeasurement, vm_4, (Item_3) => (new LocalMsg(14, [Item_3]))];
                    break;
                }
                case 3: {
                    matchValue = [securedApi(token).createCenterlineVolumeMeasurement, vm_5, (Item_4) => (new LocalMsg(14, [Item_4]))];
                    break;
                }
                case 4: {
                    matchValue = [securedApi(token).editCenterlineDistanceMeasurement, vm_6, (Item_5) => (new LocalMsg(15, [Item_5]))];
                    break;
                }
                case 5: {
                    matchValue = [securedApi(token).editDiameterRangeMeasurement, vm_7, (Item_6) => (new LocalMsg(15, [Item_6]))];
                    break;
                }
                case 6: {
                    matchValue = [securedApi(token).editLocalDiameterMeasurement, vm_8, (Item_7) => (new LocalMsg(15, [Item_7]))];
                    break;
                }
                case 7: {
                    matchValue = [securedApi(token).editCenterlineVolumeMeasurement, vm_9, (Item_8) => (new LocalMsg(15, [Item_8]))];
                    break;
                }
                default:
                    matchValue = undefined;
            }
            if (matchValue == null) {
                return [model, Toast_errorToast("Failed to save, no active measurement"), Cmd_none()];
            }
            else {
                return [new ModelCenterlineMeasurement(model.SelectedStudyId, model.CurrentStudyMeshes, model.PreviousStudyMeshes, model.Mode, model.IsEditingLabels, model.IsDeleting, true), Cmd_OfAsyncWith_either((x) => {
                    Cmd_OfAsync_start(x);
                }, matchValue[0], matchValue[1], matchValue[2], (Item_9) => (new LocalMsg(0, [Item_9]))), Cmd_none()];
            }
        }
        case 30: {
            const realEntries = makeMeasurementEntries(model.CurrentStudyMeshes.CenterlineMeasurements);
            let patternInput_6;
            const matchValue_21 = model.Mode;
            switch (matchValue_21.tag) {
                case 2: {
                    patternInput_6 = [makeMeasurementEntry(matchValue_21.fields[0].vm), realEntries];
                    break;
                }
                case 3: {
                    patternInput_6 = [makeMeasurementEntry(matchValue_21.fields[0].vm), realEntries];
                    break;
                }
                case 4: {
                    const state_27 = matchValue_21.fields[0];
                    patternInput_6 = [makeMeasurementEntry(state_27.vm), filter((entry) => (entry.measurementEntryIdSplit !== state_27.vm.measurementId), realEntries)];
                    break;
                }
                case 5: {
                    const state_28 = matchValue_21.fields[0];
                    patternInput_6 = [makeMeasurementEntry(state_28.vm), filter((entry_1) => (entry_1.measurementEntryIdSplit !== state_28.vm.measurementId), realEntries)];
                    break;
                }
                default:
                    patternInput_6 = [undefined, realEntries];
            }
            const allEntries = toList(delay(() => append_2(ofArray(toArray_1(patternInput_6[0])), delay(() => patternInput_6[1]))));
            const selectionAction = (maybeSelectionAction == null) ? (new SelectionAction$2(0, [])) : ((maybeSelectionAction[0] == null) ? ((maybeSelectionAction[1].tag === 0) ? (new SelectionAction$2(1, [])) : (new SelectionAction$2(0, []))) : ((editMode = maybeSelectionAction[1], (measurementId_9 = maybeSelectionAction[0], defaultArg(map((entry_3) => (new SelectionAction$2(3, [entry_3, editMode])), tryFind((entry_2) => (entry_2.measurementEntryIdSplit === measurementId_9), allEntries)), new SelectionAction$2(0, []))))));
            return [model, Cmd_none(), (msg_94 = (new OutboundMsg(1, [new MeasurementUpdatedOutbound$2(allEntries, selectionAction)])), singleton((dispatch_53) => {
                dispatch_53(msg_94);
            }))];
        }
        case 31:
            return [model, Cmd_none(), Cmd_none()];
        case 32:
            return defaultArg(map((vm_26) => {
                const matchValue_22 = vm_26.currentStudyValue;
                switch (matchValue_22.tag) {
                    case 1:
                        return deleteMeasurement(securedApi(token).deleteDiameterRangeMeasurement, mid_1);
                    case 2:
                        return deleteMeasurement(securedApi(token).deleteLocalDiameterMeasurement, mid_1);
                    case 3:
                        return deleteMeasurement(securedApi(token).deleteCenterlineVolumeMeasurement, mid_1);
                    default:
                        return deleteMeasurement(securedApi(token).deleteCenterlineDistanceMeasurement, mid_1);
                }
            }, tryFind((m) => (m.measurementId === mid_1), model.CurrentStudyMeshes.CenterlineMeasurements)), [model, Cmd_none(), Cmd_none()]);
        case 33:
            return [new ModelCenterlineMeasurement(model.SelectedStudyId, (bind$0040_21 = model.CurrentStudyMeshes, new StudyCenterlineMeasurement(bind$0040_21.MaybeMeshes, bind$0040_21.PointDataArrayNames, bind$0040_21.FieldDataArrayNames, filter((measurement_10) => (measurement_10.measurementId !== deleted), model.CurrentStudyMeshes.CenterlineMeasurements), bind$0040_21.CenterlinePlaneUpdater)), model.PreviousStudyMeshes, new Mode_31(0, []), model.IsEditingLabels, model.IsDeleting, model.IsSaving), singleton((dispatch_54) => {
                dispatch_54(new LocalMsg(25, [[undefined, new EditMode(0, [])]]));
            }), singleton((dispatch_55) => {
                dispatch_55(new OutboundMsg(0, [status_2]));
            })];
        case 34:
            return [model, Toast_errorToast(ErrorMessage_get_describe()(e_2)), Cmd_none()];
        default:
            return [model, Cmd_none(), Cmd_none()];
    }
}

export function update(token, msg, model) {
    return update_1(updateLocal, updateInbound, token, msg, model);
}

